"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class InventoryIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M20.625,19 L20.25,19 L20.25,4.5 C20.25,4.224 20.08125,4 19.875,4 L17.625,4 C17.418,4 17.25,4.224 17.25,4.5 L17.25,19 L15.75,19 L15.75,11.5 C15.75,11.224 15.58125,11 15.375,11 L13.125,11 C12.918,11 12.75,11.224 12.75,11.5 L12.75,19 L11.25,19 L11.25,9.5 C11.25,9.224 11.08125,9 10.875,9 L8.625,9 C8.418,9 8.25,9.224 8.25,9.5 L8.25,19 L6.75,19 L6.75,14.5 C6.75,14.224 6.58125,14 6.375,14 L4.125,14 C3.918,14 3.75,14.224 3.75,14.5 L3.75,19 L3.375,19 C3.168,19 3,19.224 3,19.5 C3,19.775 3.168,20 3.375,20 L20.625,20 C20.83125,20 21,19.775 21,19.5 C21,19.224 20.83125,19 20.625,19" })))));
    }
}
exports.InventoryIcon = InventoryIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/inventory.tsx
// module id = 2148
// module chunks = 0 1 2